type UnreadNotifier = (unread: number) => void;

let notifier: UnreadNotifier | null = null;
let lastUnread: number | null = null;

export const setUnreadNotifier = (next: UnreadNotifier | null) => {
  notifier = next;
  if (notifier && lastUnread !== null) {
    notifier(lastUnread);
  }
};

export const notifyUnread = (unread: number) => {
  lastUnread = unread;
  notifier?.(unread);
};
